<template>
    <router-link :to="to">
        <slot />
        <span>{{ label }}</span>
    </router-link>
</template>

<script>
    export default {
        name: "MenuLink",
        props:{
            to:[String, Object],
            label: String
        }
    }
</script>

<style scoped lang="scss">
    a{
        display:inline-flex;
        align-items: center;
        font-weight: 500;
        color: var(--color-grey);
        &:hover{
            color: var(--color-primary);
        }
        &.router-link-exact-active{
            color:var(--color-primary);
            font-weight: var(--font-weight-bold);
            > /deep/ svg{
                path{
                    fill: var(--color-primary);
                }
            }
        }
        >/deep/ svg{
            height: 20px;
            width: 20px;
            margin-right: 6px;
            path{
                fill: var(--color-grey);
            }
        }

        span {
            display: none;
        }
    }

    @include screen-m {
        a {
            span {
                display: inline;
            }
        }
    }
</style>
